<template>
    <Page :header="content[lang_].title" :header_pos="'center'">
        <template #body>
            <div class="flex justify-content-center flex-wrap card-container">
                <div class="flex max-w-30rem w-full align-items-center justify-content-center">
                    <form v-if="show_form" @submit.prevent="handleSubmit(!v$.$invalid)" class="flex flex-column w-full p-fluid">
                        
                        <div class="field">
                            <span class="text-color-secondary" >{{content[lang_].pass1}}*</span>
                            <div class="p-float-label">
                                <Password id="pass1" v-model="v$.pass1.$model" :class="{'p-invalid':v$.pass1.$invalid && submitted}" 
                                    class="p-inputtext-lg mt-2 mb-2 w-full border-2 border-round-lg surface-border"/>
                            </div>
                            <small v-if="(v$.pass1.$invalid && submitted) || v$.pass1.$pending.$response" class="p-error">{{v$.pass1.required.$message.replace('Value', 'Password')}}</small>
                        </div>

                        <div class="field">
                            <span class="text-color-secondary" >{{content[lang_].pass2}}*</span>
                            <div class="p-float-label">
                                <Password id="pass2" v-model="v$.pass2.$model" :class="{'p-invalid':v$.pass2.$invalid && submitted}" class="p-inputtext-lg mt-2 mb-2 w-full border-2 border-round-lg surface-border"/>
                            </div>
                            <small v-if="(v$.pass2.$invalid && submitted) || v$.pass2.$pending.$response" class="p-error">{{v$.pass2.required.$message.replace('Value', 'Password')}}</small>
                        </div>

                        <Button type="submit" :label="content[lang_].button" :loading="isLoading" class="mt-2 mb-3 p-button-lg w-full border-round-lg" />
                    </form>
                    <div v-if="show_block" class="w-full align-items-center justify-content-center">
                        <p class="w-full text-center">
                            {{ content[lang_].subtitle }} 
                        </p>
                        <Button :label="content[lang_].button_restore" @click="go_to_forgot()" class="mt-2 p-button-lg w-full border-round-lg"/>
                    </div>
                </div>
			</div>
        </template>
    </Page>
</template>


<script>
import Connect from '@/assets/js/Connect'
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { useRoute } from 'vue-router'
import Page from '@/components/sides/Page.vue'

export default {
    data() {
        return {
            content:{
                en: {
                    title: "Change password",
                    subtitle: "Link is not valid",
                    button_restore: "Restore password",
                    button: "Change",
                    pass1: "Password",
                    pass2: "Password confirmation",
                    success_title: "Success",
                    success_subtitle: "Password changed",
                },
                ru: {
                    title: "Изменение пароля",
                    subtitle: "Ссылка не действительна",
                    button_restore: "Восстановить пароль",
                    button: "Изменить",
                    pass1: "Пароль",
                    pass2: "Подтверждение пароля",
                    success_title: "Успех",
                    success_subtitle: "Пароль изменен",
                } ,
            },
            show_form: false,
            show_block: false,
            pass1: null,
            pass2: null,
            isLoading: false,
            submitted: false,
            showMessage: false,
            v$: useVuelidate(),
        }
    },
    validations() {
        return {
            pass1: {
                required,
            },
            pass2: {
                required
            },
        }
    },
    components: {
        Page
    },
    created() {
        this.connect = new Connect()
    },
    computed: {
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        isAuth: function () { return this.$store.getters.isAuthenticated },
    },
    methods: {
        go_to_forgot(){
            this.$router.push({path:'/pass/'})
        },
        showMess(severity, summary, detail) {
            this.$toast.add({severity: severity, summary: summary, detail: detail, life: 3000});
        },
        async handleSubmit(isFormValid) {
            this.isLoading = true
            this.submitted = true;
            if (!isFormValid) {
                this.isLoading = false
                return;
            }

            if(this.pass1!=this.pass2) {
                this.showMess('error', 'Error', 'Passwords are not equal', 1000)
                this.isLoading = false
                return
            }

            const forgot = await this.connect.change_pass(this.hash, this.pass1, this.pass2).then(res=>res)
            if(!forgot.result) {
                for (let i = 0; i < forgot.errors.length; i++) {
                    this.showMess('error', 'Error', forgot.errors[i])
                }
            }else{
                this.showMess('success', this.content[this.lang_].success_title, this.content[this.lang_].success_subtitle)
                this.$router.push({ path: '/auth/' }) 
            }
            this.isLoading = false
            this.submitted = false
        },
    },
    mounted(){
        if(this.isAuth){
            this.$router.push({ path: '/' })
        }
    },
    async beforeCreate(){
        this.connect = new Connect()
        const route = useRoute()
        if(route.params.hash!='') this.hash = route.params.hash

        if(this.hash){
            let get_acces_by_hash = await this.connect.get_hash(this.hash).then(res=>res)
            if(get_acces_by_hash.result){
                this.show_form = true
            }else{
                this.show_block = true
            }
        }
    }
}
</script>